import card1a from "./cards/BrainBreak cards4.png";
import card1b from "./cards/BrainBreak cards5.png";
import card2a from "./cards/BrainBreak cards6.png";
import card2b from "./cards/BrainBreak cards7.png";
import card3a from "./cards/BrainBreak cards8.png";
import card3b from "./cards/BrainBreak cards9.png";
import card4a from "./cards/BrainBreak cards10.png";
import card4b from "./cards/BrainBreak cards11.png";
import card5a from "./cards/BrainBreak cards12.png";
import card5b from "./cards/BrainBreak cards13.png";
import card6a from "./cards/BrainBreak cards14.png";
import card6b from "./cards/BrainBreak cards15.png";
import card7a from "./cards/BrainBreak cards16.png";
import card7b from "./cards/BrainBreak cards17.png";
import card8a from "./cards/BrainBreak cards18.png";
import card8b from "./cards/BrainBreak cards19.png";
import card9a from "./cards/BrainBreak cards20.png";
import card9b from "./cards/BrainBreak cards21.png";
import card10a from "./cards/BrainBreak cards22.png";
import card10b from "./cards/BrainBreak cards23.png";
import card11a from "./cards/BrainBreak cards24.png";
import card11b from "./cards/BrainBreak cards25.png";
import card12a from "./cards/BrainBreak cards26.png";
import card12b from "./cards/BrainBreak cards27.png";
import card13a from "./cards/BrainBreak cards28.png";
import card13b from "./cards/BrainBreak cards29.png";
import card14a from "./cards/BrainBreak cards30.png";
import card14b from "./cards/BrainBreak cards31.png";
import card15a from "./cards/BrainBreak cards32.png";
import card15b from "./cards/BrainBreak cards33.png";
import card16a from "./cards/BrainBreak cards34.png";
import card16b from "./cards/BrainBreak cards35.png";
import card17a from "./cards/BrainBreak cards36.png";
import card17b from "./cards/BrainBreak cards37.png";
import card18a from "./cards/BrainBreak cards38.png";
import card18b from "./cards/BrainBreak cards39.png";
import card19a from "./cards/BrainBreak cards40.png";
import card19b from "./cards/BrainBreak cards41.png";
import card20a from "./cards/BrainBreak cards42.png";
import card20b from "./cards/BrainBreak cards43.png";
import card21a from "./cards/BrainBreak cards44.png";
import card21b from "./cards/BrainBreak cards45.png";
import card22a from "./cards/BrainBreak cards46.png";
import card22b from "./cards/BrainBreak cards47.png";
import card23a from "./cards/BrainBreak cards48.png";
import card23b from "./cards/BrainBreak cards49.png";
import card24a from "./cards/BrainBreak cards50.png";
import card24b from "./cards/BrainBreak cards51.png";
import card25a from "./cards/BrainBreak cards52.png";
import card25b from "./cards/BrainBreak cards53.png";
import card26a from "./cards/BrainBreak cards54.png";
import card26b from "./cards/BrainBreak cards55.png";
import card27a from "./cards/BrainBreak cards56.png";
import card27b from "./cards/BrainBreak cards57.png";
import card28a from "./cards/BrainBreak cards58.png";
import card28b from "./cards/BrainBreak cards59.png";
import card29a from "./cards/BrainBreak cards60.png";
import card29b from "./cards/BrainBreak cards61.png";
import card30a from "./cards/BrainBreak cards62.png";
import card30b from "./cards/BrainBreak cards63.png";
import card31a from "./cards/BrainBreak cards64.png";
import card31b from "./cards/BrainBreak cards65.png";
import card32a from "./cards/BrainBreak cards66.png";
import card32b from "./cards/BrainBreak cards67.png";
import card33a from "./cards/BrainBreak cards68.png";
import card33b from "./cards/BrainBreak cards69.png";
import card34a from "./cards/BrainBreak cards70.png";
import card34b from "./cards/BrainBreak cards71.png";
import card35a from "./cards/BrainBreak cards72.png";
import card35b from "./cards/BrainBreak cards73.png";
import card36a from "./cards/BrainBreak cards74.png";
import card36b from "./cards/BrainBreak cards75.png";
import card37a from "./cards/BrainBreak cards76.png";
import card37b from "./cards/BrainBreak cards77.png";
import card38a from "./cards/BrainBreak cards78.png";
import card38b from "./cards/BrainBreak cards79.png";
import card39a from "./cards/BrainBreak cards80.png";
import card39b from "./cards/BrainBreak cards81.png";
import card40a from "./cards/BrainBreak cards82.png";
import card40b from "./cards/BrainBreak cards83.png";
import card41a from "./cards/BrainBreak cards84.png";
import card41b from "./cards/BrainBreak cards85.png";
import card42a from "./cards/BrainBreak cards86.png";
import card42b from "./cards/BrainBreak cards87.png";
import card43a from "./cards/BrainBreak cards88.png";
import card43b from "./cards/BrainBreak cards89.png";
import card44a from "./cards/BrainBreak cards90.png";
import card44b from "./cards/BrainBreak cards91.png";
import card45a from "./cards/BrainBreak cards92.png";
import card45b from "./cards/BrainBreak cards93.png";
import card46a from "./cards/BrainBreak cards94.png";
import card46b from "./cards/BrainBreak cards95.png";
import card47a from "./cards/BrainBreak cards96.png";
import card47b from "./cards/BrainBreak cards97.png";
import card48a from "./cards/BrainBreak cards98.png";
import card48b from "./cards/BrainBreak cards99.png";
import card49a from "./cards/BrainBreak cards100.png";
import card49b from "./cards/BrainBreak cards101.png";
import card50a from "./cards/BrainBreak cards102.png";
import card50b from "./cards/BrainBreak cards103.png";
import card51a from "./cards/BrainBreak cards104.png";
import card51b from "./cards/BrainBreak cards105.png";
import card52a from "./cards/BrainBreak cards106.png";
import card52b from "./cards/BrainBreak cards107.png";

export const CARDS = [
  [card1a, card1b],
  [card2a, card2b],
  [card3a, card3b],
  [card4a, card4b],
  [card5a, card5b],
  [card6a, card6b],
  [card7a, card7b],
  [card8a, card8b],
  [card9a, card9b],
  [card10a, card10b],
  [card11a, card11b],
  [card12a, card12b],
  [card13a, card13b],
  [card14a, card14b],
  [card15a, card15b],
  [card16a, card16b],
  [card17a, card17b],
  [card18a, card18b],
  [card19a, card19b],
  [card20a, card20b],
  [card21a, card21b],
  [card22a, card22b],
  [card23a, card23b],
  [card24a, card24b],
  [card25a, card25b],
  [card26a, card26b],
  [card27a, card27b],
  [card28a, card28b],
  [card29a, card29b],
  [card30a, card30b],
  [card31a, card31b],
  [card32a, card32b],
  [card33a, card33b],
  [card34a, card34b],
  [card35a, card35b],
  [card36a, card36b],
  [card37a, card37b],
  [card38a, card38b],
  [card39a, card39b],
  [card40a, card40b],
  [card41a, card41b],
  [card42a, card42b],
  [card43a, card43b],
  [card44a, card44b],
  [card45a, card45b],
  [card46a, card46b],
  [card47a, card47b],
  [card48a, card48b],
  [card49a, card49b],
  [card50a, card50b],
  [card51a, card51b],
  [card52a, card52b]
];
